const selfSelector = (state) => state.toastsApp

export default selfSelector
